var number = require('./number');

var date = require('./date');

var time = require('./time');

var mobile = require('./mobile');

var consumer = require('./consumer');

var fr = {
  'number': number,
  'date': date,
  'time': time,
  'mobile': mobile,
  'consumer': consumer
};
module.exports = fr;